var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 67,
    viewBox: "0 0 61 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1617 64.9677C57.2443 64.9677 59.4919 62.0786 58.7598 59.0926C56.1176 48.334 46.3723 40.3447 34.7569 40.3447C23.1414 40.3447 13.3904 48.334 10.7539 59.0983C10.0219 62.0843 12.2695 64.9677 15.352 64.9677H54.1617Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7568 34.9653C42.151 34.9653 48.1451 28.9928 48.1451 21.6252C48.1451 14.2577 42.151 8.28516 34.7568 8.28516C27.3626 8.28516 21.3684 14.2577 21.3684 21.6252C21.3684 28.9928 27.3626 34.9653 34.7568 34.9653Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41298 57.2177C8.62055 48.2255 14.3053 41.1651 24.2851 37.8828C13.0414 38.2589 2.71846 45.4105 0.139152 55.9127C-0.59289 58.8987 1.65471 61.7821 4.73729 61.7821H7.24225C6.37295 60.5057 6.00693 58.8759 6.41298 57.2177Z",
    fill: "#FCC240"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3592 18.9701C17.3592 10.7188 24.0734 4.02881 32.3546 4.02881C35.2828 4.02881 38.0165 4.86648 40.3213 6.31389C37.7763 2.51302 33.4298 0 28.4942 0C20.6591 0 14.3052 6.33098 14.3052 14.1436C14.3052 17.8988 15.7807 21.3122 18.177 23.848C17.6508 22.3151 17.3592 20.6797 17.3592 18.9701Z",
    fill: "#FCC240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.791ae62c61e52dc75180725f45a8c240.svg";
export { ForwardRef as ReactComponent };